<template>
  <div class="h-pg-root hidden-md-and-up">
    <div class="space-20"/>
    <span class="h-pg-title ">为什么选择我们</span>
    <div class="h-pg-top-bar margin-top-20">
      <span class="h-pg-top-bar-text">以顾客为重，全心全意为您排忧解难</span>
    </div>
    <div class="h-pg-content">
      <div class="wm-item margin-top-15">
        <div class="wm-item-img-bg">
          <img src="@/assets/home/whyme/img_tuandui.png" class="wm-item-img">
        </div>
        <div class="wm-item-title-line"/>
        <div class="wm-item-content">
          <span class="wm-item-title margin-top-15">
            专家团队保障
          </span>
          <span class="wm-item-text margin-top-15">
            多位专家级团队成员，具备10年的丰富从业经验，已成功为5000+中小企业提供了优质服务，凭借深厚的行业积淀，能够精准满足各类企业需求。
          </span>
        </div>
      </div>
      <div class="wm-item margin-top-15">
        <div class="wm-item-img-bg">
          <img src="@/assets/home/whyme/img_quanfangwei.png" class="wm-item-img">
        </div>
        <div class="wm-item-title-line"/>
        <div class="wm-item-content">
          <span class="wm-item-title margin-top-15">
            多方位支持
          </span>
          <span class="wm-item-text margin-top-15">
            为您提供权威且针对性的指导建议，迅速且高质量地解决您企业所面临的信用问题。与您保持紧密沟通，实时向您同步每一项具体工作的进展情况。
          </span>
        </div>
      </div>
      <div class="wm-item margin-top-15">
        <div class="wm-item-img-bg">
          <img src="@/assets/home/whyme/img_gaozhiliang.png" class="wm-item-img">
        </div>
        <div class="wm-item-title-line"/>
        <div class="wm-item-content">
          <span class="wm-item-title margin-top-15">
            高质量让您省心
          </span>
          <span class="wm-item-text margin-top-15">
            量身定制高质量的维护策略，以精准、高质量的行动，确保整个维护过程顺畅无阻，让企业信用维护变得轻松简单，获得客户广泛好评。
          </span>
        </div>
      </div>
      <div class="wm-item margin-top-15 margin-bottom-15">
        <div class="wm-item-img-bg">
          <img src="@/assets/home/whyme/img_feiyong.png" class="wm-item-img">
        </div>
        <div class="wm-item-title-line"/>
        <div class="wm-item-content">
          <span class="wm-item-title margin-top-15">
            费用实惠透明
          </span>
          <span class="wm-item-text margin-top-15">
            采用透明的核算方式，针对每一项具体事务进行单独商议定价，确保价格公开、清晰可查。若未能达成预期服务要求，承诺绝不收取费用。
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>

</script>

<style scoped>
.h-pg-root {
  width: 100%;
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.h-pg-title {
  font-size: 15px;
  color: #2f2f2f;
  font-weight: bold;
}

.h-pg-top-bar {
  background-color: #dde3f3;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  width: 92%;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.h-pg-content {
  width: 92%;
  border-bottom-right-radius: 10px;
  border-bottom-left-radius: 10px;
  background: linear-gradient(to top right, #fefcff, #dde3f3);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}


.h-pg-top-bar-text {
  font-size: 14px;
  color: #1b57ec;
}

.wm-item {
  /*background-color: #ffffff;*/
  border-radius: 10px;
  width: 93%;
  display: flex;
  flex-direction: column;
  position: relative;
}
.wm-item-img-bg{
  width: 45px;
  height: 45px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #ffffff;
  border-radius: 30px;
  position: absolute;
  border: 1px solid #1b57ec;
  left: 20px;
}
.wm-item-img {
  width: 30px;
  height: 30px;
  /*box-shadow: 0 0 10px #1b57ec;*/
}

.wm-item-title-line {
  width: 100%;
  height: 15px;
  margin-top: 20px;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  background-color: #1b57ec;
}
.wm-item-content{
  /*margin-top: 35px;*/
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  display: flex;
  flex-direction: column;
  padding: 20px;
  box-sizing: border-box;
  border: 1px solid #f1f7ff;
}
.wm-item-title{
  font-size: 15px;
  color: #2a2a2a;
  font-weight: bold;
  letter-spacing: 1px;
}
.wm-item-text{
  font-size: 13px;
  color: #444444;
  letter-spacing: 1px;
  line-height: 25px;
}
</style>
